import { createRoot } from "react-dom/client";
import "./index.css";
import { patchReactAriaCollectionNodes } from "src/config/reactAriaDevPatch";
import Provider from "./Provider";

// i18n needs to be bundled
import "src/general/localization/i18n";

patchReactAriaCollectionNodes();

const rootElement = document.getElementById("root");
if (rootElement) {
  createRoot(rootElement).render(<Provider />);
} else {
  throw new Error("Root element not found");
}
